import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';

import { 
  bankingRequiredRoutes, 
  familyRestrictedRoutes, 
  nonMemberRestrictedRoutes, 
  terminatedAllowedRoutes, 
  terminatedInClaimPeriodAllowedRoutes 
} from './Routes.js';
import {  groupPlans } from '../../utility/common/GlobalHSA';
import WrapperMain from '../../components/wrappers/WrapperMain.js';

function RouteAdmin({
  component: Component,
  componentName,
  authType,
  isAdmin,
  missingPersonalInfo,
  missingPersonalBanking,
  missingCompanyInfo,
  missingCompanyBanking,

  bankingInfoWaived,
  
  newEmployeeCheck,
  pwResetRequired,
  accountFrozen,
  isNonMemberAdmin,
  contractType,
  terminatedFlag,
  claimPeriodEnded,
  token,
  expiry,
  ...rest
}) {

  const currentLocation = useLocation();

  //catch missing required props
  if(!authType || !isAdmin || !token || !expiry) {
    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/login", state: {from: props.location} }} /> )
        }
      />
    );
  }

  //catch if user is not a BC
  if(isAdmin !== 'Y') {
    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/", state: {from: props.location} }} /> )
        }
      />
    );
  }


  //hsa agreement check
  if(newEmployeeCheck === true && currentLocation.pathname !== '/hsa-agreement') {
    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/hsa-agreement", state: {from: props.location} }} /> )
        }
      />
    );
  }

  //missing personal info check
  else if(missingPersonalInfo ===  'Y' && currentLocation.pathname !== '/employee' && newEmployeeCheck !== true) {

    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/employee", state: {from: props.location} }} /> )
        }
      />
    );
  }

  //missing personal banking check
  // else if(missingPersonalBanking ===  'Y' && missingPersonalInfo !==  'Y' && currentLocation.pathname !== '/banking-details' && newEmployeeCheck !== true && isNonMemberAdmin !== 'Y') {
  //
  //   return (
  //     <Route
  //       {...rest}
  //       render={props => (<Redirect to={{ pathname: "/banking-details", state: {from: props.location} }} /> )
  //       }
  //     />
  //   );
  // }

  //missing company info check
  // else if(missingCompanyInfo === 'Y' && missingPersonalBanking !==  'Y' && missingPersonalInfo !==  'Y' && isAdmin ===  'Y' && currentLocation.pathname !== '/employer' && newEmployeeCheck !== true) {
  else if(missingCompanyInfo === 'Y' && missingPersonalInfo !==  'Y' && isAdmin ===  'Y' && currentLocation.pathname !== '/employer' && newEmployeeCheck !== true) {

    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/employer", state: {from: props.location} }} /> )
        }
      />
    );
  }
  //missing company info check
  // else if( missingCompanyBanking ===  'Y' && (bankingRequiredRoutes.includes(currentLocation.pathname) || groupPlans.includes(contractType)) && missingCompanyInfo !== 'Y' && missingPersonalBanking !==  'Y' && missingPersonalInfo !==  'Y' && isAdmin ===  'Y' && currentLocation.pathname !== '/business-banking' && newEmployeeCheck !== true) {
  else if( missingCompanyBanking ===  'Y' && bankingInfoWaived != 'Y' && (bankingRequiredRoutes.includes(currentLocation.pathname) || contractType == 13) && missingCompanyInfo !== 'Y' && missingPersonalInfo !==  'Y' && isAdmin ===  'Y' && currentLocation.pathname !== '/business-banking' && newEmployeeCheck !== true) {

    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/business-banking", state: {from: props.location} }} /> )
        }
      />
    );
  }

  else if(terminatedFlag === 'Y' && claimPeriodEnded === 'Y' && !terminatedAllowedRoutes.includes(currentLocation.pathname)){
    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/", state: {from: props.location} }} /> )
        }
      />
    );
  }

  else if(terminatedFlag === 'Y' && claimPeriodEnded === 'N' && !terminatedInClaimPeriodAllowedRoutes.includes(currentLocation.pathname)){
    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/", state: {from: props.location} }} /> )
        }
      />
    );
  }

  else if(!groupPlans.includes(parseInt(contractType)) && familyRestrictedRoutes.includes(currentLocation.pathname)){
    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/", state: {from: props.location} }} /> )
        }
      />
    );
  }

  else if(isNonMemberAdmin === 'Y' && nonMemberRestrictedRoutes.includes(currentLocation.pathname)){

    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/", state: {from: props.location} }} /> )
        }
      />
    );
  }

  //check expiry
  const currentDate = parseInt(new Date().getTime() / 1000);
  const expiryDate = parseInt(expiry);
  //check reducer store and local token values
  const validToken = (token === localStorage.getItem('token'))? true : false;
  const validDate = (currentDate < expiryDate)? true : false;
  
  return(
        <Route
          {...rest}
          render={props =>
              (authType === 'EMPLOYEE' && isAdmin === 'Y' && validToken && validDate) ?
                (<React.Suspense fallback={<WrapperMain inSuspense={true}/>}>
                  <Component {...props} />
                </React.Suspense>) :
                (<Redirect to={{ pathname: "/logout", state: {from: props.location} }} /> )
          }
        />
  );
}

export default RouteAdmin;
